import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import tw from "tailwind-styled-components";
import {
  FiUploadCloud,
  FiImage,
  FiTrash2,
} from "react-icons/fi";

const ProfileLogo = ({ apiData }) => {
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    if (apiData?.logo) {
      setLogo(apiData.logo);
    }
  }, [apiData]);

  const onDrop = useCallback((acceptedFiles) => {
    if (!acceptedFiles.length) return;

    const file = acceptedFiles[0];

    file.preview = URL.createObjectURL(file);

    setLogo(file);
  }, []);

  const { getRootProps, getInputProps, open } = useDropzone({
  multiple: false,
  maxFiles: 1,
  accept: ".png,.jpg,.jpeg,.webp,.svg",
  onDrop,
  noClick: true,
});

  const removeLogo = () => {
    setLogo(null);
  };

  return (
    <Wrapper>
      <Title>Business Logo</Title>

      <Content>

        {/* Preview */}

        <Preview>

          {logo ? (
            <Logo
              src={logo.preview || logo}
              alt=""
            />
          ) : (
            <Placeholder>
              <FiImage
                size={42}
                className="text-gray-400"
              />
            </Placeholder>
          )}

        </Preview>

        {/* Upload */}

        <Right>

          <UploadArea {...getRootProps()}>

            <input {...getInputProps()} />

            <FiUploadCloud
              size={42}
              className="text-primary-color"
            />

            <UploadTitle>
              Upload Business Logo
            </UploadTitle>

            <UploadSubtitle>
              Drag & Drop or Click to Browse
            </UploadSubtitle>

            <UploadInfo>
              PNG • JPG • JPEG • WEBP • SVG
            </UploadInfo>

          </UploadArea>

          <ButtonWrapper>

            <UploadButton {...getRootProps()}>

              <input {...getInputProps()} />

              {logo
                ? "Change Logo"
                : "Upload Logo"}

            </UploadButton>

            {logo && (
              <DeleteButton
                onClick={removeLogo}
              >
                <FiTrash2 size={15} />

                Remove
              </DeleteButton>
            )}

          </ButtonWrapper>

        </Right>

      </Content>
    </Wrapper>
  );
};

export default ProfileLogo;

/* ---------------- Styles ---------------- */

const Wrapper = tw.div`
space-y-5
`;

const Title = tw.h3`
text-lg
font-semibold
text-gray-900
`;

const Content = tw.div`
grid
grid-cols-1
lg:grid-cols-[160px_1fr]
gap-8
items-start
`;

const Preview = tw.div`
flex
justify-center
`;

const Placeholder = tw.div`
w-40
h-40
rounded-2xl
border
border-gray-200
bg-gray-50
flex
items-center
justify-center
`;

const Logo = tw.img`
w-40
h-40
rounded-2xl
border
object-contain
bg-white
p-4
`;

const Right = tw.div`
space-y-5
`;

const UploadArea = tw.div`
border-2
border-dashed
border-gray-300
rounded-2xl
bg-gray-50
h-40
cursor-pointer
transition-all
hover:border-primary-color
hover:bg-blue-50
flex
flex-col
items-center
justify-center
text-center
`;

const UploadTitle = tw.p`
mt-3
font-semibold
text-gray-800
`;

const UploadSubtitle = tw.p`
text-sm
text-gray-500
mt-1
`;

const UploadInfo = tw.p`
text-xs
text-gray-400
mt-2
`;

const ButtonWrapper = tw.div`
flex
gap-3
`;

const UploadButton = tw.button`
px-5
py-2.5
rounded-lg
bg-primary-color
text-white
font-medium
hover:opacity-90
`;

const DeleteButton = tw.button`
px-5
py-2.5
rounded-lg
border
border-red-200
text-red-600
font-medium
hover:bg-red-50
flex
items-center
gap-2
`;